module.exports = __webpack_public_path__ + "media/images/badge/debuttante_secondary-66f7ece58dc63ce6cfcae14a70c52d57.png";